// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! * [Scalable Text in CSS with Maximum and Minimum Sizes](https://github.com/kevinmack18/SCALABLE-TEXT-IN-CSS) */.multiselect__tags{border-color:#000}.multiselect__input::-moz-placeholder{color:#5b5952}.multiselect__input:-ms-input-placeholder{color:#5b5952}.multiselect__input::placeholder{color:#5b5952}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
